import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  companyCrudApi,
  companyExtendedApi,
  mediaCrudApi,
} from "../client/EntityApi";
import CrudTable, {
  ICrudTableRefMethods,
} from "../core/component/crud/CrudTable";
import { SyncOutlined } from "@ant-design/icons";
import {
  getCompanyFilesCPColumns,
  getCompanyFilesCPFormItems,
} from "../components/crud/CompanyFilesCPComponents";
import { AuthHelper } from "../core/helper/AuthHelper";

const CompanyFilesCrudPage = () => {
  const { id } = useParams<{ id: string }>();
  const crudPageRef = useRef<ICrudTableRefMethods>(null);
  const [company, setCompany] = useState<any>();

  useEffect(() => {
    if (id) {
      companyCrudApi.get(parseInt(id)).then((response) => setCompany(response));
    }
  }, [id]);

  const getCompanyFiles = () => {
    return id
      ? companyExtendedApi.getCompanyFiles(parseInt(id))
      : new Promise((resolve) => resolve({ "hydra:member": [] }));
  };

  return (
    <>
      <CrudTable
        ref={crudPageRef}
        entityLabel="İşletme Dosyası"
        customTableTitle={() =>
          company ? (
            <b>{company.name} - Dosya Listesi</b>
          ) : (
            <SyncOutlined spin />
          )
        }
        api={mediaCrudApi}
        getAll={getCompanyFiles}
        searchKeys={["name"]}
        columns={getCompanyFilesCPColumns()}
        addFormItems={getCompanyFilesCPFormItems(id!)}
        editFormItems={getCompanyFilesCPFormItems(id!)}
        hideEditProcess
        hideAddProcess={!AuthHelper.checkVisibility("İşletme Dosyası Ekle")}
        hideDeleteProcess={!AuthHelper.checkVisibility("İşletme Dosyası Sil")}
        post={(values: any) => {
          const mediaId = values.media.split("/").pop();
          return mediaCrudApi.edit(parseInt(mediaId), {
            name: values.name,
            company: values.company,
          });
        }}
      />
    </>
  );
};

export default CompanyFilesCrudPage;